import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/chisquare/cdf';
import __var_2__ from '@stdlib/stats/base/dists/chisquare/ctor';
import __var_3__ from '@stdlib/stats/base/dists/chisquare/entropy';
import __var_4__ from '@stdlib/stats/base/dists/chisquare/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/chisquare/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/chisquare/mean';
import __var_7__ from '@stdlib/stats/base/dists/chisquare/median';
import __var_8__ from '@stdlib/stats/base/dists/chisquare/mgf';
import __var_9__ from '@stdlib/stats/base/dists/chisquare/mode';
import __var_10__ from '@stdlib/stats/base/dists/chisquare/pdf';
import __var_11__ from '@stdlib/stats/base/dists/chisquare/quantile';
import __var_12__ from '@stdlib/stats/base/dists/chisquare/skewness';
import __var_13__ from '@stdlib/stats/base/dists/chisquare/stdev';
import __var_14__ from '@stdlib/stats/base/dists/chisquare/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace chisquare
*/
var chisquare = {};

/**
* @name cdf
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/cdf}
*/
setReadOnly( chisquare, 'cdf', __var_1__);

/**
* @name ChiSquare
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/ctor}
*/
setReadOnly( chisquare, 'ChiSquare', __var_2__);

/**
* @name entropy
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/entropy}
*/
setReadOnly( chisquare, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/kurtosis}
*/
setReadOnly( chisquare, 'kurtosis', __var_4__);

/**
* @name logpdf
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/logpdf}
*/
setReadOnly( chisquare, 'logpdf', __var_5__);

/**
* @name mean
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/mean}
*/
setReadOnly( chisquare, 'mean', __var_6__);

/**
* @name median
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/median}
*/
setReadOnly( chisquare, 'median', __var_7__);

/**
* @name mgf
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/mgf}
*/
setReadOnly( chisquare, 'mgf', __var_8__);

/**
* @name mode
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/mode}
*/
setReadOnly( chisquare, 'mode', __var_9__);

/**
* @name pdf
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/pdf}
*/
setReadOnly( chisquare, 'pdf', __var_10__);

/**
* @name quantile
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/quantile}
*/
setReadOnly( chisquare, 'quantile', __var_11__);

/**
* @name skewness
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/skewness}
*/
setReadOnly( chisquare, 'skewness', __var_12__);

/**
* @name stdev
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/stdev}
*/
setReadOnly( chisquare, 'stdev', __var_13__);

/**
* @name variance
* @memberof chisquare
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/chisquare/variance}
*/
setReadOnly( chisquare, 'variance', __var_14__);


// EXPORTS //
export default chisquare;

export { __var_1__ as cdf, __var_2__ as ChiSquare, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as median, __var_8__ as mgf, __var_9__ as mode, __var_10__ as pdf, __var_11__ as quantile, __var_12__ as skewness, __var_13__ as stdev, __var_14__ as variance};